import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Picker, EmojiIndex } from 'emoji-mart-vue-fast/src';
import data from '../../../../../assets/emojis.json';
import { nanoid } from 'nanoid';
import { nextTick, onBeforeMount, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'EmojiPicker',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
},
  emits: ["insertEmoji"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const pickerId = ref('');
const isUp = ref(false);

const ei = new EmojiIndex(data, { recentLength: 8, exclude: ['flags', 'symbols'] });

onBeforeMount(() => (pickerId.value = nanoid(7)));

watch(
  () => props.show,
  () => nextTick(() => (isUp.value = isEmojiPickerUp())),
  { immediate: true },
);

function addVariableToText(variable: any) {
  emit('insertEmoji', variable);
}

function getEmojiPickerId() {
  return `emoji-picker-${pickerId.value}`;
}

function isEmojiPickerUp() {
  const menu = document.querySelector(`#${getEmojiPickerId()}`);
  if (menu) {
    const position = menu.getBoundingClientRect();
    const padding = 10;
    if (position.bottom > window.innerHeight - padding) {
      return true;
    }
  }
  return false;
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["picker-position", { 'is-down': !isUp.value, 'is-up': isUp.value }])
  }, [
    _createVNode(_unref(Picker), {
      id: getEmojiPickerId(),
      "emoji-size": 21,
      perLine: 9,
      native: true,
      showPreview: false,
      data: _unref(ei),
      onSelect: addVariableToText,
      class: "emoji-picker"
    }, null, 8, ["id", "data"]),
    _createElementVNode("div", {
      class: _normalizeClass({ 'arrow-down': isUp.value, 'arrow-up': !isUp.value })
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "inner-arrow" }, null, -1)
    ]), 2)
  ], 2)), [
    [_vShow, __props.show]
  ])
}
}

})